<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="固定话术" prop="content">
        <Input v-model="formValidate.content" placeholder="请输入固定话术"></Input>
      </FormItem>

      <FormItem label="平台"  prop="live_id">
        <Select v-model="formValidate.live_id">
          <Option
            v-for="item in liveTypes"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="所属分类"  prop="classify_id" v-if="classifyIds.length > 1">
        <Select v-model="formValidate.classify_id" @on-change="classifyChange">
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="所属标签" prop="tag_id" >
        <Select v-model="formValidate.tag_id" clearable>
          <Option
            v-for="item in tagIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="类型" prop="type_id" >
        <Select v-model="formValidate.type_id">
          <Option
            v-for="item in types"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import {getClassifyTag, getActionTypeList} from "@/api/data";
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      tagIds:[],
      types:[],
      liveTypes:[],
      formValidate: {
        id: '',
        content: '',
        classify_id:0,
        tag_id:0,
        type_id:'',
        live_id:''
      },
      ruleValidate: {
        content: [
          {
            required: true,
            message: '固定话术不能为空',
            trigger: 'blur'
          }
        ],
        classify_id: [
          {
            required: true,
            message: '所属分类必须要选择',
            trigger: 'change'
          }
        ],
        type_id: [
          {
            required: true,
            message: '类型必须要选择',
            trigger: 'change'
          }
        ],live_id: [
          {
            required: true,
            message: '平台必须要选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    classifyChange(value){

      if (value == undefined){
        return
      }

       var params = {
          classify_id: value
        }
        getClassifyTag(params).then((res) => {
        var tagIds = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < tagIds.length; i++) {
          data[i] = { id: tagIds[i].id.toString(), name: tagIds[i].tag}
        }
        this.tagIds = data
        });
    },    setLiveType (live_type_list) {
      var data = new Array()
      for (var i = 0; i < live_type_list.length; i++) {
        data[i] = { id: live_type_list[i].id.toString(), name: live_type_list[i].name }
      }
      this.liveTypes = data
    },
    getActionTypes(){
      getActionTypeList({}).then((res) => {
        var actionIds = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < actionIds.length; i++) {
          data[i] = { id: actionIds[i].value.toString(), name: actionIds[i].name}
        }
        this.types = data
      });
    },
    setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.classify_id = data.classify_id.toString()
      this.formValidate.tag_id = data.tag_id.toString()
      this.formValidate.type_id = data.type.toString()
      this.formValidate.live_id = data.live_id.toString()
      this.classifyChange(data.classify_id)

      this.formValidate.content = data.content
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }, mounted() {
    this.classifyChange(0);
    this.getActionTypes()
  }
}
</script>
